{
  "es": {
    "account": {
      "build_your_profile": "Completa tu perfil",
      "my_bookings": "Mis Reservas de Experiencias",
      "my_orders": "Mis Pedidos",
      "my_registries": "Mis Registros de Regalo",
      "profile": "Perfil",
      "profile_overview": "Resumen del Perfil",
      "settings": "Configuración"
    },
    "activerecord": {
      "attributes": {
        "address": {
          "apartment": "Edificio / Apartamento / Extensión",
          "contact_name": "Nombre de contacto",
          "contact_phone": "Teléfono",
          "contact_phone_mobile": "Teléfono móvil",
          "door": "Número de puerta",
          "name": "Alias",
          "phone": "Teléfono",
          "phone_mobile": "Teléfono móvil",
          "shipping_zone_id": "Ciudad",
          "street": "Calle"
        },
        "alliance_order": {
          "statuses": {
            "active": "Activo",
            "cancelled": "Cancelado",
            "invoiced": "Facturado"
          }
        },
        "bank_transfer_payment": {
          "voucher": "Comprobante"
        },
        "bucket": {
          "alli_code": "Código Alliance",
          "credit_agreements": {
            "cash": "Contado",
            "forty_five_days": "45 días",
            "thirty_days": "30 días",
            "twenty_days": "20 días"
          },
          "kind": "Tributación",
          "kinds": {
            "final_consumer": "Consumidor final",
            "fiscal_credit": "Crédito fiscal",
            "governmental": "Gubernamental",
            "normal": "Normal",
            "special_regimes": "Regímenes especiales"
          },
          "name": "Nombre",
          "plan": "Plan",
          "plans": {
            "basic": "Básico",
            "normal": "Normal",
            "pro": "Pro",
            "staff": "Staff de Asi"
          }
        },
        "bucket_address": {
          "apartment": "Edificio / Apartamento / Extensión",
          "contact_name": "Nombre de contacto",
          "contact_phone": "Teléfono",
          "contact_phone_mobile": "Teléfono móvil",
          "door": "Número de puerta",
          "name": "Alias",
          "phone": "Teléfono",
          "phone_mobile": "Teléfono móvil",
          "shipping_zone_id": "Ciudad",
          "street": "Calle"
        },
        "category": {
          "body": "Descripción",
          "description": "Descripción (SEO)",
          "image": "Imagen",
          "name": "Nombre",
          "parent": "Categoría madre",
          "parent_id": "Categoría madre",
          "statuses": {
            "active": "Activa",
            "inactive": "Inactiva"
          }
        },
        "credit_line_request": {
          "bank_ref_one_account": "No. Cuenta 1",
          "bank_ref_one_branch": "Sucursal 1",
          "bank_ref_one_name": "Banco 1",
          "bank_ref_one_phone": "Tel 1",
          "bank_ref_three_account": "No. cuenta 3",
          "bank_ref_three_branch": "Sucursal 3",
          "bank_ref_three_name": "Banco 3",
          "bank_ref_three_phone": "Tel 3",
          "bank_ref_two_account": "No. Cuenta 2",
          "bank_ref_two_branch": "Sucursal 2",
          "bank_ref_two_name": "Banco 2",
          "bank_ref_two_phone": "Tel 2",
          "finances_email": "Email",
          "finances_ext": "Ext.",
          "finances_manager_name": "Nombre del gerente financiero",
          "finances_phone": "Teléfono",
          "has_second_branch": "Tiene la empresa otra sucursal?",
          "last_day_to_invoices": "Última fecha para recibir facturas",
          "owner_id": "No. Documento de identidad personal",
          "owner_identification": "No. Documento de identidad personal",
          "owner_name": "Nombre del propiertario o gerente general",
          "owner_nationality": "Nacionalidad",
          "owner_phone": "Teléfono Móvil",
          "owner_residential_phone": "Teléfono residencial",
          "payment_method_bank_transfer": "transferencia bancaria",
          "payment_method_cash": "Efectivo",
          "payment_method_cc": "Tarjeta crédito/débito *",
          "purchasing_manager_email": "Email",
          "purchasing_manager_ext": "Ext",
          "purchasing_manager_name": "Nombre del encargado",
          "purchasing_manager_phone": "Teléfono",
          "purchasing_sub_manager_email": "Email",
          "purchasing_sub_manager_ext": "Ext",
          "purchasing_sub_manager_name": "Nombre del sub-encargado",
          "purchasing_sub_manager_phone": "Teléfono",
          "ref_one_company_name": "Empresa 1",
          "ref_one_contact_name": "Contacto 1",
          "ref_one_phone": "Teléfono 1",
          "ref_three_company_name": "Empresa 3",
          "ref_three_contact_name": "Contacto 3",
          "ref_three_phone": "Teléfono 3",
          "ref_two_company_name": "Empresa 2",
          "ref_two_contact_name": "Contacto 2",
          "ref_two_phone": " Teléfono 2",
          "requested_amount": "Monto del crédito solicitado",
          "second_branch_address": "Dirección",
          "second_branch_city": "Ciudad",
          "second_branch_email": "Email",
          "second_branch_fax": "Fax",
          "second_branch_phone": "Teléfono",
          "second_branch_principal_name": "Contacto principal",
          "statuses": {
            "approved": "Arpobado",
            "declined": "Declinado",
            "pending": "Pendiente"
          },
          "time_in_market": "Tiempo en el mercado"
        },
        "discount": {
          "kind": "Tipo",
          "kinds": {
            "amount": "Monto ($RD)",
            "percentage": "Porcentaje"
          },
          "name": "Nombre",
          "status": "Estado",
          "statuses": {
            "active": "Activo",
            "inactive": "Inactivo"
          },
          "value": "Valor"
        },
        "discountable_discount": {
          "discount_id": "Descuento"
        },
        "document": {
          "description": "Descripción",
          "name": "Nombre"
        },
        "order": {
          "invoice_voucher_kinds": {
            "final_consumer": "Consumidor final",
            "fiscal_credit": "Crédito fiscal",
            "governmental": "Gubernamental",
            "special_regimes": "Regímenes especiales"
          },
          "statuses": {
            "authorized": "Autorizada",
            "fraudulent": "Fraude",
            "paid": "Pagada",
            "partially_paid": "Pago parcial",
            "partially_refunded": "Reembolso parcial",
            "pending": "Incompleta",
            "refunded": "Reembolsada",
            "unpaid": "Sin pagar",
            "voided": "Anulada"
          }
        },
        "package": {
          "statuses": {
            "canceled": "Cancelado",
            "completed": "Completado",
            "in_preparation": "Preparando",
            "pending": "Pendiente",
            "picked_up": "Recogido",
            "ready_for_pickup": "Listo para entrega"
          }
        },
        "payment": {
          "amount": "Monto",
          "note": "Nota",
          "statuses": {
            "cancelled": "Cancelado",
            "completed": "Completado",
            "pending": "Pendiente",
            "refunded": "Reembolzado",
            "unpaid": "Sin pagar",
            "voided": "Evitado"
          }
        },
        "post": {
          "body": "Cuerpo",
          "cover": "Portada",
          "cover_alt": "Alt de portada",
          "description": "Descripción",
          "name": "Nombre",
          "post_category": "Categoría",
          "published_at": "Publicado el",
          "status": "Estado",
          "statuses": {
            "archived": "Archivado",
            "published": "Publicado",
            "unpublished": "Sin publicar"
          }
        },
        "product": {
          "description": "Dice el fabricante",
          "discounted_price": "Precio con Descuento",
          "dp_id": "ID externo",
          "dp_margin_percentage": "Margen min deseado (%)",
          "dp_price": "Precio externo",
          "dp_vendor": "Plataforma externa",
          "dp_vendors": {
            "interfacedo": "Interface S.A.",
            "none": "Ninguna",
            "omega_tech": "Omega Tech",
            "pricesmart": "Pricesmart"
          },
          "featured_image": "Imagen destacada",
          "name": "Nombre",
          "price": "Precio",
          "quantity_per_box": "Cnt. por caja",
          "shipping_package": "Empacado",
          "shipping_packages": {
            "automatic": "Auto",
            "big": "Grande",
            "medium": "Mediano",
            "pallet": "Paleta",
            "small": "Estándar"
          },
          "short_description": "Descripción corta",
          "status": "Estado",
          "statuses": {
            "archived": "Archivado",
            "published": "Publicado",
            "unpublished": "Sin publicar"
          },
          "warehouse_location": "Ubicación en almacén"
        },
        "shipment": {
          "statuses": {
            "fulfilled": "Entregado",
            "partially_fulfilled": "Articulos pendientes",
            "scheduled": "Agendado",
            "unfulfilled": "Sin preparar"
          }
        },
        "shipping_zone": {
          "kind": "Zona",
          "name": "Nombre"
        },
        "system_setting": {
          "hero_one_img": "Imagen del primer espacio del hero",
          "hero_one_url": "Enlace del primer espacio del hero",
          "hero_three_img": "Imagen del tercer espacio del hero",
          "hero_three_url": "Enlace del tercer espacio del hero",
          "hero_two_img": "Imagen del segundo espacio del hero",
          "hero_two_url": "Enlace del segundo espacio del hero",
          "last_banner_img": "Imagen del último banner (Home)",
          "last_banner_url": "Enlace del último banner (Home)",
          "middle_banner_img": "Imagen del banner en el medio (Home)",
          "middle_banner_url": "Enlace del banner en el medio (Home)"
        },
        "user": {
          "branch": "Sucursal",
          "branches": {
            "santiago": "Santiago",
            "santo_domingo": "Santo Domingo"
          },
          "current_password": "Contraseña actual",
          "email": "Correo electrónico",
          "first_name": "Nombre",
          "kinds": {
            "company": "Empresa",
            "person": "Persona"
          },
          "last_name": "Apellido",
          "name": "Nombre completo",
          "password": "Contraseña",
          "password_confirmation": "Repetir contraseña",
          "phone": "Teléfono",
          "price_lvl": "Nivel de precio",
          "remember_me": "Permanecer conectado",
          "role": "Ról",
          "roles": {
            "admin": "Admin",
            "customer": "Cliente",
            "pro_employee": "Colaborador",
            "pro_principal": "Principal",
            "pro_shopping_assistant": "Auxiliar de compras",
            "staff_fresh": "Nuevo ingreso",
            "staff_management": "Gerente",
            "staff_sales": "Agente de ventas",
            "staff_warehouse": "Almacén",
            "supplier": "Suplidor"
          }
        },
        "warehouse": {
          "address": "Dirección",
          "bucket_id": "Proveedor",
          "dropshipping": "Dropshipping",
          "name": "Nombre",
          "statuses": {
            "published": "Publicado",
            "unpublished": "Sin publicar"
          },
          "with_delivery": "Delivery",
          "with_pick_up": "Pickup"
        },
        "whats_app_representative": {
          "name": "Nombre",
          "phone": "Número de WhatsApp",
          "statuses": {
            "active": "Activo",
            "inactive": "Inactivo"
          }
        }
      },
      "errors": {
        "models": {
          "address": {
            "attributes": {
              "apartment": {
                "blank": "%{attribute} es obligatorio"
              },
              "contact_name": {
                "blank": "%{attribute} es obligatorio"
              },
              "contact_phone": {
                "invalid": "%{attribute} no es valido"
              },
              "contact_phone_mobile": {
                "invalid": "%{attribute} no es valido"
              },
              "door": {
                "blank": "%{attribute} es obligatorio"
              },
              "name": {
                "blank": "%{attribute} es obligatorio"
              },
              "sector": {
                "blank": "%{attribute} es obligatorio"
              },
              "shipping_zone": {
                "required": "es obligatorio"
              },
              "street": {
                "blank": "%{attribute} es obligatorio"
              }
            }
          },
          "bank_transfer_payment": {
            "attributes": {
              "voucher": {
                "blank": "debes adjuntar el comprobante"
              }
            }
          },
          "bucket": {
            "attributes": {
              "address": {
                "blank": "es obligatorio"
              },
              "alli_code": {
                "taken": "no está disponible"
              },
              "contact_name": {
                "blank": "es obligatorio"
              },
              "contact_phone": {
                "blank": "es obligatorio"
              },
              "name": {
                "blank": "es obligatorio"
              },
              "rnc": {
                "blank": "es obligatorio"
              }
            }
          },
          "bucket_address": {
            "attributes": {
              "apartment": {
                "blank": "%{attribute} es obligatorio"
              },
              "contact_phone": {
                "invalid": "%{attribute} no es valido"
              },
              "contact_phone_mobile": {
                "invalid": "%{attribute} no es valido"
              },
              "door": {
                "blank": "%{attribute} es obligatorio"
              },
              "first_name": {
                "blank": "%{attribute} es obligatorio"
              },
              "name": {
                "blank": "%{attribute} es obligatorio"
              },
              "sector": {
                "blank": "%{attribute} es obligatorio"
              },
              "shipping_zone": {
                "required": "es obligatorio"
              },
              "street": {
                "blank": "%{attribute} es obligatorio"
              }
            }
          },
          "catalog": {
            "attributes": {
              "file": {
                "blank": "es obligatorio"
              },
              "name": {
                "blank": "es obligatorio"
              }
            }
          },
          "discount": {
            "attributes": {
              "delivery_method": {
                "taken": "ya esta en uso"
              },
              "name": {
                "blank": "es obligatorio"
              }
            }
          },
          "discountable_discount": {
            "attributes": {
              "discount": {
                "required": "es obligatorio"
              }
            }
          },
          "document": {
            "attributes": {
              "name": {
                "blank": "%{attribute} es obligatorio"
              }
            }
          },
          "estimate": {
            "attributes": {
              "address_id": {
                "required": "es obligatorio"
              }
            }
          },
          "join_bucket": {
            "attributes": {
              "code": {
                "blank": "%{attribute} es obligatorio"
              },
              "id": {
                "blank": "%{attribute} es obligatorio"
              }
            }
          },
          "order": {
            "attributes": {
              "address_id": {
                "blank": "donde deseas recibir tu pedido"
              },
              "delivery_method": {
                "blank": "elige un método de entrega"
              },
              "invoice_identification": {
                "blank": "es obligatorio"
              },
              "invoice_name": {
                "blank": "es obligatorio"
              },
              "invoice_voucher_kind": {
                "blank": "es obligatorio"
              },
              "warehouse_id": {
                "blank": "donde deseas buscar tu pedido"
              }
            }
          },
          "payment_transfer": {
            "attributes": {
              "voucher": {
                "blank": "%{attribute} es obligatorio"
              }
            }
          },
          "user": {
            "attributes": {
              "current_password": {
                "blank": "%{attribute} es obligatoria",
                "invalid": "%{attribute} es invalida"
              },
              "email": {
                "blank": "%{attribute} es obligatorio",
                "taken": "ya esta en uso",
                "too_long": "Debe tener %{count} caracteres máximo",
                "too_short": "Debe tener %{count} caracteres mínimo"
              },
              "first_name": {
                "blank": "%{attribute} es obligatorio",
                "too_long": "Debe tener %{count} caracteres máximo",
                "too_short": "Debe tener %{count} caracteres mínimo"
              },
              "name": {
                "blank": "%{attribute} es obligatorio",
                "too_long": "Debe tener %{count} caracteres máximo",
                "too_short": "Debe tener %{count} caracteres mínimo"
              },
              "password": {
                "blank": "%{attribute} es obligatoria",
                "too_long": "Debe tener %{count} caracteres máximo",
                "too_short": "Debe tener %{count} caracteres mínimo"
              },
              "password_confirmation": {
                "confirmation": "Debe ser igual que tu contraseña"
              },
              "phone": {
                "blank": "es obligatorio",
                "invalid": "%{attribute} no es valido"
              }
            }
          }
        }
      },
      "models": {
        "address": "Dirección",
        "invoice": "Factura",
        "order": "Orden",
        "payment_link": "Link de pago",
        "user": "Usuario"
      }
    },
    "admin": {
      "bank_transfer_payments": {
        "approve": "Aprobar Pago",
        "approved": "Pago aprobado exitosamente.",
        "reject": "Rechazar Pago",
        "rejected": "Pago rechazado exitosamente.",
        "title": "Pagos por Transferencia",
        "view_title": "Detalles del Pago"
      },
      "categories": {
        "create_button": "Crear Categoría",
        "created": "Categoría creada exitosamente.",
        "deleted": "Categoría eliminada exitosamente.",
        "edit_title": "Editar Categoría",
        "new_title": "Nueva Categoría",
        "seo_keywords_help": "Palabras clave SEO (separadas por coma).",
        "title": "Categorías",
        "update_button": "Actualizar Categoría",
        "updated": "Categoría actualizada exitosamente."
      },
      "coupons": {
        "archived": "Cupón archivado exitosamente.",
        "create_button": "Crear Cupón",
        "created": "Cupón creado exitosamente.",
        "edit_title": "Editar Cupón",
        "new_title": "Nuevo Cupón",
        "restored": "Cupón restaurado exitosamente.",
        "title": "Cupones",
        "update_button": "Actualizar Cupón",
        "updated": "Cupón actualizado exitosamente."
      },
      "dashboard": {
        "title": "Panel de Control"
      },
      "experience_bookings": {
        "title": "Reservas de Experiencias",
        "view_title": "Detalles de la Reserva"
      },
      "experiences": {
        "archived": "Experiencia archivada exitosamente.",
        "create_button": "Crear Experiencia",
        "created": "Experiencia creada exitosamente.",
        "edit_title": "Editar Experiencia",
        "new_title": "Nueva Experiencia",
        "restored": "Experiencia restaurada exitosamente.",
        "title": "Experiencias",
        "update_button": "Actualizar Experiencia",
        "updated": "Experiencia actualizada exitosamente."
      },
      "orders": {
        "title": "Pedidos",
        "view_title": "Detalles del Pedido"
      },
      "posts": {
        "archived": "Publicación archivada exitosamente.",
        "create_button": "Crear Publicación",
        "created": "Publicación creada exitosamente.",
        "edit_title": "Editar Publicación",
        "new_title": "Nueva Publicación",
        "restored": "Publicación restaurada exitosamente.",
        "title": "Publicaciones",
        "update_button": "Actualizar Publicación",
        "updated": "Publicación actualizada exitosamente."
      },
      "products": {
        "archive_product": "Archivar Producto",
        "archived": "Producto archivado exitosamente.",
        "basic_information": "Información Básica",
        "create_button": "Crear Producto",
        "created": "Producto creado exitosamente.",
        "description_help": "Descripción completa del producto mostrada en la página del producto",
        "edit_title": "Editar Producto",
        "featured_position_help": "Establece un número de posición para destacar este producto en la página principal.",
        "manage_variants": "Administrar Variantes",
        "media": "Medios",
        "new_title": "Nuevo Producto",
        "pricing_stock": "Precios y Stock",
        "quick_actions": "Acciones Rápidas",
        "restored": "Producto restaurado exitosamente.",
        "seo": "SEO",
        "short_description_help": "Resumen breve mostrado en listados de productos",
        "title": "Productos",
        "update_button": "Actualizar Producto",
        "updated": "Producto actualizado exitosamente.",
        "variants": "Variantes",
        "view_on_store": "Ver en Tienda"
      },
      "registries": {
        "title": "Registros de Regalo",
        "view_title": "Detalles del Registro"
      },
      "shared": {
        "actions": "Acciones",
        "all": "Todos",
        "archive": "Archivar",
        "cancel": "Cancelar",
        "create": "Crear",
        "created_at": "Creado",
        "delete": "Eliminar",
        "edit": "Editar",
        "filter": "Filtrar",
        "restore": "Restaurar",
        "save": "Guardar",
        "search": "Buscar",
        "status": "Estado",
        "translatable_content": "Contenido Traducible",
        "translatable_content_help": "Ingresa el contenido en cada idioma. Inglés es requerido, español es opcional.",
        "update": "Actualizar",
        "updated_at": "Actualizado",
        "view": "Ver"
      },
      "users": {
        "edit_title": "Editar Usuario",
        "new_title": "Nuevo Usuario",
        "title": "Usuarios"
      }
    },
    "auth": {
      "already_have_account": "¿Ya tienes una cuenta?",
      "back": "Volver",
      "back_to_home": "Volver al inicio",
      "change_password": "Cambiar tu contraseña",
      "confirm_new_password": "Confirmar nueva contraseña",
      "continue_with_email": "Continuar con correo",
      "create_account": "Crear una cuenta",
      "current_password": "Contraseña actual",
      "dont_have_account": "¿No tienes una cuenta?",
      "email": "Correo Electrónico",
      "enter_email_address": "Ingresa tu correo electrónico...",
      "errors_prohibited": "%{count} error(es) impidieron guardar este usuario:",
      "forgot_password": "¿Olvidaste tu contraseña?",
      "invalid_code": "Código inválido o expirado",
      "log_out": "Cerrar sesión",
      "new_password": "Nueva contraseña",
      "password": "Contraseña",
      "password_confirmation": "Confirmar contraseña",
      "password_minimum": "Mínimo 12 caracteres.",
      "remember_me": "Recordarme",
      "save_changes": "Guardar cambios",
      "sign_in": "Iniciar Sesión",
      "sign_in_without_password": "Iniciar sesión sin contraseña",
      "sign_out": "Cerrar Sesión",
      "sign_up": "Registrarse",
      "signed_in": "Sesión iniciada exitosamente",
      "signed_out": "Sesión cerrada exitosamente",
      "verification_sent": "Hemos enviado la invitación a tu correo",
      "welcome": "¡Bienvenido! Te has registrado exitosamente",
      "whats_your_email": "¿Cuál es tu correo electrónico?"
    },
    "breadcrumbs": {
      "blog": "Blog",
      "home": "Inicio",
      "store": "Tienda"
    },
    "cart": {
      "bank_transfer": "Transferencia Bancaria",
      "cart_updated": "Carrito actualizado",
      "checkout": "Pagar",
      "checkout_with_price": "Pagar - %{price}",
      "continue_shopping": "Continuar comprando",
      "coupon": {
        "applied": "Cupón aplicado",
        "apply": "Aplicar",
        "invalid": "Inválido",
        "placeholder": "Ingresa código",
        "removed": "Cupón eliminado",
        "title": "Código de Cupón"
      },
      "credit_debit_card": "Tarjeta de Crédito/Débito",
      "delivery_method": "Método de envío",
      "discount": "Descuento",
      "discrete_delivery": "Envío discreto a domicilio",
      "empty": "Tu carrito está vacío",
      "empty_bag": "Tu bolsa de compras está vacía",
      "empty_message": "Agrega artículos a tu carrito para comenzar.",
      "estimated_total": "Total Estimado",
      "explore_collection": "Explora nuestra colección",
      "item_removed": "Artículo eliminado",
      "items_in_bag": "Artículos en tu Bolsa",
      "my_bag": "Mi Bolsa",
      "order_summary": "Resumen del Pedido",
      "payment_method": "Método de pago",
      "paypal": "PayPal",
      "pickup": "Recoger en tienda",
      "quantity": "Cantidad",
      "related_products": "Productos Relacionados",
      "subtotal": "Subtotal",
      "title": "Mi Carrito",
      "total": "Total"
    },
    "cart_items": {
      "color": "Color",
      "confirm_delete": "¿Seguro que deseas eliminar este artículo?",
      "gift_from": "Regalo de %{registry_name}",
      "qty": "Cant",
      "recipient_wants": "Nota: El destinatario solo quiere %{quantity} de este artículo",
      "size": "Talla",
      "unit": "Unidad"
    },
    "categories": {
      "all_products": "Todos los Productos",
      "apply_filters": "Aplicar Filtros",
      "browse_all": "Ver Todos los Productos",
      "clear_all": "Limpiar todo",
      "colors": "Colores",
      "filter_by": "Filtrar Por",
      "filter_by_colon": "Filtrar por:",
      "no_filters_available": "No hay filtros disponibles",
      "no_products": "Aún no hay productos en esta categoría.",
      "our_pieces_of_art": "Nuestras Piezas de Arte",
      "shop_by_categories": "Comprar por Categorías",
      "shop_now": "Comprar Ahora",
      "sizes": "Tallas",
      "sort": {
        "label": "Ordenar por",
        "newest": "Más Recientes",
        "price_asc": "Precio: Menor a Mayor",
        "price_desc": "Precio: Mayor a Menor"
      },
      "title": "Tienda",
      "view_results": "Ver resultados (%{count})"
    },
    "checkout": {
      "billing_address": "Dirección de Facturación",
      "delivery_address": "Dirección de Entrega",
      "delivery_fee": "Costo de envío",
      "different_address": "Usar una dirección diferente",
      "discount": "Descuento",
      "empty_bag": "Tu bolsa de compras está vacía",
      "explore_collection": "Explora nuestra colección",
      "free": "Gratis",
      "items_in_bag": "Artículos en tu Bolsa",
      "my_bag": "Mi Bolsa",
      "order_summary": "Resumen del Pedido",
      "payment_method": "Método de Pago",
      "payment_method_disclaimer": {
        "bank_transfer": "<strong>Al hacer clic en \"Realizar Pedido\", confirmas que estás realizando un pedido con obligación de pago a Fancy Sinner mediante transferencia bancaria.</strong><br><br>Después de confirmar tu pedido, te mostraremos y/o enviaremos por correo nuestros datos bancarios e instrucciones de pago. Tu pedido será procesado una vez que confirmemos la recepción de los fondos. Al realizar tu pedido, aceptas los <strong>Términos de Venta de Fancy Sinner</strong> y la <strong>Política de Privacidad</strong>, y nos autorizas a usar y compartir tus datos personales según sea necesario para gestionar tu pedido y pago de acuerdo con esas políticas.",
        "paypal": "<strong>Al hacer clic en \"Realizar Pedido\" y continuar a PayPal, confirmas que estás realizando una compra con obligación de pago a Fancy Sinner.</strong><br><br>Tu pago será procesado a través de <strong>PayPal</strong>. Al completar tu pedido, aceptas los <strong>Términos de Venta de Fancy Sinner</strong> y la <strong>Política de Privacidad</strong>, y reconoces que PayPal procesará tu información de pago de acuerdo con el <strong>Acuerdo de Usuario de PayPal</strong> y la <strong>Declaración de Privacidad de PayPal</strong>.",
        "stripe": "<strong>Al hacer clic en \"Realizar Pedido\", confirmas que estás realizando una compra con obligación de pago a Fancy Sinner.</strong><br><br>Tu pago será procesado a través de <strong>Stripe</strong>. Al completar tu pedido, aceptas los <a href=\"%{terms}\" class=\"underline\">Términos de Venta de Fancy Sinner</a> y la <a href=\"%{privacy}\" class=\"underline\">Política de Privacidad</a>."
      },
      "pickup_address": "C/ Calle el Cayao #13. Piso 2, Serrallés. Distrito Nacional, República Dominicana.",
      "pickup_at_store": "Recoger en tienda",
      "pickup_notification": "Te notificaremos cuando tu pedido esté listo para recoger.",
      "place_order": "Realizar Pedido",
      "processing": "Procesando...",
      "same_as_billing": "Igual a la dirección de facturación",
      "shipping_address": "Dirección de Envío",
      "subtotal": "Subtotal",
      "title": "Checkout",
      "total": "Total"
    },
    "common": {
      "add_to_cart": "Agregar al Carrito",
      "apply": "Aplicar",
      "back": "Volver",
      "cancel": "Cancelar",
      "continue_shopping": "Continuar Comprando",
      "create": "Crear",
      "delete": "Eliminar",
      "edit": "Editar",
      "loading": "Cargando...",
      "next": "Siguiente",
      "no_results": "No se encontraron resultados",
      "optional": "opcional",
      "previous": "Anterior",
      "proceed_to_checkout": "Ir al Checkout",
      "proceed_to_payment": "Proceder al Pago",
      "remove": "Eliminar",
      "required": "requerido",
      "save": "Guardar",
      "start_shopping": "Comenzar a Comprar",
      "update": "Actualizar",
      "view": "Ver",
      "view_details": "Ver Detalles"
    },
    "create_account": "Crea una cuenta",
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%-d/%-m/%Y",
        "long": "%-d de %B de %Y",
        "short": "%-d de %b",
        "short_with_year": "%B %-d, %Y"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "alrededor de 1 hora",
          "other": "alrededor de %{count} horas"
        },
        "about_x_months": {
          "one": "alrededor de 1 mes",
          "other": "alrededor de %{count} meses"
        },
        "about_x_years": {
          "one": "alrededor de 1 año",
          "other": "alrededor de %{count} años"
        },
        "almost_x_years": {
          "one": "casi 1 año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de 1 minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de 1 segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de 1 año",
          "other": "más de %{count} años"
        },
        "short": {
          "about_x_hours": {
            "one": "1hr",
            "other": "%{count}hrs"
          },
          "about_x_months": {
            "one": "1m",
            "other": "%{count}meses"
          },
          "about_x_years": {
            "one": "1año",
            "other": "%{count}años"
          },
          "almost_x_years": {
            "one": "casi 1 año",
            "other": "casi %{count} años"
          },
          "half_a_minute": "medio minuto",
          "less_than_x_minutes": {
            "one": "menos de 1 minuto",
            "other": "menos de %{count} minutos"
          },
          "less_than_x_seconds": {
            "one": "menos de 1 segundo",
            "other": "menos de %{count} segundos"
          },
          "over_x_years": {
            "one": "1a+",
            "other": "%{count}a+"
          },
          "x_days": {
            "one": "1d",
            "other": "%{count}d"
          },
          "x_minutes": {
            "one": "1m",
            "other": "%{count}min"
          },
          "x_months": {
            "one": "1mes",
            "other": "%{count}meses"
          },
          "x_seconds": {
            "one": "1s",
            "other": "%{count}s"
          },
          "x_years": {
            "one": "1a",
            "other": "%{count}a"
          }
        },
        "x_days": {
          "one": "1 día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "1 minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "1 mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "1 segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "1 año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "errors": {
      "not_found": "Página no encontrada",
      "something_went_wrong": "Algo salió mal",
      "unauthorized": "No estás autorizado para ver esta página"
    },
    "experience_bookings": {
      "amount": "Monto",
      "booked_on": "Reservado el",
      "booking_confirmed": "Reserva Confirmada",
      "booking_date": "Fecha de Reserva",
      "booking_number": "Reserva %{number}",
      "card": "Tarjeta",
      "confirmation": "Confirmación:",
      "confirmation_details": "Detalles de Confirmación",
      "confirmation_number": "Número de Confirmación",
      "duration": "Duración:",
      "experience": "Experiencia",
      "explore_experiences": "Explorar Experiencias",
      "no_bookings": "Aún no hay reservas de experiencias",
      "no_bookings_message": "Cuando reserves una experiencia, aparecerá aquí.",
      "paid_via": "Pagado con",
      "payment": "Pago",
      "status": "Estado",
      "status_messages": {
        "cancelled": {
          "description": "Si tienes alguna pregunta sobre la cancelación, contáctanos.",
          "title": "Esta reserva ha sido cancelada"
        },
        "completed": {
          "description": "¡Gracias por acompañarnos! Esperamos que hayas disfrutado.",
          "title": "Experiencia completada"
        },
        "confirmed": {
          "description": "Esperamos verte pronto. Si tienes alguna pregunta, contáctanos.",
          "title": "¡Tu experiencia está programada!"
        },
        "pending": {
          "description": "Nos comunicaremos pronto para programar tu experiencia.",
          "title": "Pago recibido"
        },
        "processing": {
          "description": "Estamos trabajando en programar tu experiencia. Por favor revisa tu correo para actualizaciones.",
          "title": "Estamos en contacto contigo"
        }
      },
      "success": {
        "amount_paid": "Monto Pagado",
        "booking_details": "Detalles de la Reserva",
        "email_sent_html": "Se ha enviado un correo de confirmación a <strong>%{email}</strong>",
        "max_group_size": "Tamaño Máximo del Grupo",
        "meta_title": "Reserva Confirmada - %{name}",
        "next_step": "Siguiente Paso: Agenda Tu Fecha",
        "people": {
          "one": "1 persona",
          "other": "%{count} personas"
        },
        "schedule_description": "Contáctanos por WhatsApp para elegir tu fecha y hora preferida. Confirmaremos disponibilidad y finalizaremos tu reserva.",
        "schedule_on_whatsapp": "Agendar por WhatsApp",
        "thank_you_html": "Gracias por reservar <strong>%{name}</strong>",
        "title": "¡Reserva Confirmada!",
        "whatsapp_message": "¡Hola! Acabo de reservar %{name} y me gustaría agendar mi sesión. Mi número de confirmación es %{confirmation}."
      },
      "title": "Mis Reservas de Experiencias",
      "total": "Total",
      "view_details": "Ver Detalles",
      "view_experience": "Ver Experiencia"
    },
    "experiences": {
      "book_now": "Reservar Ahora",
      "cta": {
        "description": "Asegura tu %{name} hoy y crea recuerdos inolvidables con tu grupo.",
        "title": "¿Lista para Reservar?"
      },
      "duration": "Duración",
      "fancy_sinner_experiences": "Experiencias Fancy Sinner",
      "faqs": "Preguntas Frecuentes",
      "group_size": "Tamaño del Grupo",
      "how_to_book": {
        "step1_description": "Haz clic en \"Reservar Ahora\" y completa tu pago de forma segura en línea. Recibirás una confirmación inmediatamente.",
        "step1_title": "Paso 1: Reserva en Línea",
        "step2_description": "Después de reservar, contáctanos por WhatsApp para elegir tu fecha y hora preferida. Confirmaremos la disponibilidad.",
        "step2_title": "Paso 2: Agenda por WhatsApp",
        "step3_description": "Llega a nuestra tienda y disfruta de una experiencia inolvidable con tu grupo. ¡Todo está listo para ti!",
        "step3_title": "Paso 3: Disfruta la Experiencia",
        "title": "Cómo Reservar - Solo 3 Pasos Fáciles"
      },
      "no_experiences": "No hay experiencias disponibles",
      "other_experiences": "Otras Experiencias",
      "our_clients_say": "Lo Que Dicen Nuestras Clientas",
      "policies": "Políticas",
      "price": "Precio",
      "reviews": "Reseñas",
      "share": "Compartir",
      "time": "Hora",
      "up_to_people": "Hasta %{count} personas",
      "whats_included": "Qué Incluye",
      "why_choose": "¿Por qué elegir %{name} en Fancy Sinner?"
    },
    "flash": {
      "admin": {
        "bank_transfer_payments": {
          "approval_failed": "Error al aprobar el pago: %{message}",
          "approved": "Pago aprobado y pedido #%{order_number} creado.",
          "cart_already_paid": "No se puede aprobar: El carrito ya fue pagado. El pedido %{order_number} existe.",
          "invalid_payment_type": "Tipo de pago inválido",
          "rejected": "Pago rechazado.",
          "rejection_reason_required": "Por favor proporciona una razón para el rechazo",
          "select_file": "Por favor selecciona un archivo para subir",
          "voucher_upload_failed": "Error al subir el comprobante",
          "voucher_uploaded": "Comprobante subido exitosamente"
        },
        "bookings": {
          "status_updated": "Estado de la reserva actualizado a %{status}."
        },
        "categories": {
          "created": "Categoría creada",
          "deleted": "Categoría eliminada",
          "updated": "Categoría actualizada"
        },
        "comparison_items": {
          "created": "Elemento de comparación agregado.",
          "deleted": "Elemento de comparación eliminado.",
          "updated": "Elemento de comparación actualizado."
        },
        "coupons": {
          "archived": "Cupón archivado exitosamente.",
          "created": "Cupón creado exitosamente.",
          "restored": "Cupón restaurado exitosamente.",
          "updated": "Cupón actualizado exitosamente."
        },
        "experiences": {
          "archived": "Experiencia archivada exitosamente.",
          "created": "Experiencia creada exitosamente.",
          "restored": "Experiencia restaurada exitosamente.",
          "updated": "Experiencia actualizada exitosamente."
        },
        "faqs": {
          "created": "FAQ agregada.",
          "deleted": "FAQ eliminada.",
          "updated": "FAQ actualizada."
        },
        "orders": {
          "status_updated": "Estado del pedido actualizado a %{status}."
        },
        "posts": {
          "archived": "Publicación archivada exitosamente.",
          "created": "Publicación creada exitosamente.",
          "restored": "Publicación restaurada exitosamente.",
          "updated": "Publicación actualizada exitosamente."
        },
        "products": {
          "archived": "Producto archivado exitosamente.",
          "created": "Producto creado exitosamente.",
          "restored": "Producto restaurado exitosamente.",
          "updated": "Producto actualizado exitosamente."
        },
        "registries": {
          "updated": "Registro actualizado exitosamente."
        },
        "reviews": {
          "created": "Reseña agregada.",
          "deleted": "Reseña eliminada.",
          "updated": "Reseña actualizada."
        },
        "users": {
          "updated": "Usuario actualizado"
        },
        "variants": {
          "created": "Variante creada exitosamente.",
          "deleted": "Variante eliminada.",
          "updated": "Variante actualizada."
        }
      },
      "archived": "%{resource} archivado exitosamente.",
      "auth": {
        "email_changed": "Tu correo ha sido cambiado",
        "email_verified": "Gracias por verificar tu dirección de correo",
        "fill_email": "Ingresa tu dirección de correo",
        "invalid_code": "Código inválido o expirado",
        "invalid_credentials": "El correo o contraseña es incorrecto",
        "invalid_reset_link": "Ese enlace de restablecimiento es inválido",
        "invalid_sign_in_link": "Ese enlace de inicio de sesión es inválido",
        "invalid_verification_link": "Ese enlace de verificación es inválido",
        "not_authorized": "No autorizado",
        "password_changed": "Tu contraseña ha sido cambiada",
        "password_reset_success": "Tu contraseña fue restablecida exitosamente. Por favor inicia sesión",
        "reset_instructions_sent": "Revisa tu correo para las instrucciones de restablecimiento",
        "session_logged_out": "Esa sesión ha sido cerrada",
        "signed_in": "Sesión iniciada exitosamente",
        "signed_out": "Sesión cerrada exitosamente",
        "try_again_later": "Intenta más tarde",
        "verification_email_sent": "Hemos enviado un correo de verificación a tu dirección",
        "verification_sent": "Hemos enviado la invitación a tu correo %{email}.",
        "verify_email_first": "No puedes restablecer tu contraseña hasta que verifiques tu correo",
        "welcome": "¡Bienvenido! Te has registrado exitosamente"
      },
      "bookings": {
        "unable_to_process": "No se pudo procesar la reserva. Por favor intenta de nuevo."
      },
      "cart": {
        "empty": "Tu carrito está vacío",
        "invalid_quantity": "Cantidad inválida",
        "item_removed": "Artículo eliminado",
        "items_added": "%{quantity} artículo(s) agregado(s) al carrito",
        "only_available": "Solo %{quantity} disponible(s) en stock",
        "option_out_of_stock": "La opción seleccionada está agotada",
        "out_of_stock": "Agotado",
        "quantity_unavailable": "Cantidad no disponible en stock",
        "select_color": "Por favor selecciona un color",
        "select_size": "Por favor selecciona una talla",
        "select_valid_option": "Por favor selecciona una opción válida",
        "updated": "Carrito actualizado"
      },
      "checkout": {
        "fields_have_errors": "Algunos campos tienen errores"
      },
      "coupons": {
        "already_used": "Ya has usado este cupón",
        "applied": "¡Cupón aplicado exitosamente!",
        "cannot_apply": "Este cupón no se puede aplicar",
        "expired": "Este cupón ha expirado",
        "first_time_only": "Este cupón es solo para clientes nuevos",
        "inactive": "Este cupón está inactivo",
        "invalid": "Código de cupón inválido",
        "minimum_required": "Se requiere un pedido mínimo de %{amount}",
        "not_yet_valid": "Este cupón aún no es válido",
        "removed": "Cupón eliminado",
        "usage_limit_reached": "Este cupón ha alcanzado su límite de uso"
      },
      "created": "%{resource} creado exitosamente.",
      "deleted": "%{resource} eliminado.",
      "invitations": {
        "sent": "Se ha enviado un correo de invitación a %{email}"
      },
      "payments": {
        "bank_transfer": {
          "invalid_payment": "Pago inválido",
          "voucher_already_uploaded": "El comprobante ya fue subido",
          "voucher_required": "Por favor sube un comprobante",
          "voucher_upload_failed": "Error al subir el comprobante",
          "voucher_uploaded": "Comprobante subido exitosamente. Revisaremos tu pago y te notificaremos pronto."
        },
        "cancelled": "Pago cancelado",
        "capture_failed": "Error al capturar el pago: %{details}",
        "error": "Error en el procesamiento del pago",
        "invalid_session": "Sesión de pago inválida",
        "not_approved": "El pago no fue aprobado",
        "not_found": "Pago no encontrado",
        "paypal": {
          "checkout_failed": "Error al crear el checkout de PayPal",
          "order_failed": "Error al crear la orden de PayPal"
        },
        "stripe_error": "Error de pago: %{message}",
        "success": "¡Pago exitoso! Tu pedido ha sido confirmado."
      },
      "registry": {
        "already_purchased": "Este artículo ya ha sido comprado.",
        "created": "Registro creado exitosamente.",
        "deleted": "Registro eliminado.",
        "gift_added_to_cart": "¡Regalo agregado al carrito!",
        "item_added": "¡Agregado a tu registro!",
        "item_removed": "Artículo eliminado del registro.",
        "item_updated": "Artículo actualizado.",
        "options_unavailable": "Las opciones seleccionadas no están disponibles.",
        "quantity_updated": "Cantidad actualizada en tu registro.",
        "select_color": "Por favor selecciona un color antes de agregar al registro.",
        "select_size": "Por favor selecciona una talla antes de agregar al registro.",
        "updated": "Registro actualizado exitosamente."
      },
      "restored": "%{resource} restaurado exitosamente.",
      "subscriptions": {
        "pick_destination": "Necesitas elegir el destino",
        "pick_frequency": "Necesitas elegir una frecuencia",
        "pick_plan": "Necesitas elegir un plan"
      },
      "updated": "%{resource} actualizado exitosamente."
    },
    "footer": {
      "about_us": "Sobre Nosotros",
      "addresses": "Direcciones:",
      "categories": "Categorías",
      "closed": "Cerrado",
      "contact": "Contacto",
      "copyright": "Copyright - Fancy Sinner Lingerie",
      "experience": "Experiencia",
      "fancy_blog": "Fancy Blog",
      "faqs": "Preguntas Frecuentes",
      "mail": "Correo:",
      "monday_to_friday": "Lunes a Viernes:",
      "open": "Horario:",
      "phone": "Teléfono:",
      "privacy_policy": "Política de Privacidad",
      "return_policy": "Política de Devoluciones",
      "saturdays": "Sábados:",
      "sunday": "Domingo:",
      "terms_and_conditions": "Términos y Condiciones",
      "we_are": "Nosotros"
    },
    "forgot_password": "¿Olvidaste tu contraseña?",
    "header": {
      "admin": "Admin",
      "cart": "Carrito",
      "profile": "Perfil",
      "search": "Buscar",
      "sign_in": "Iniciar Sesión",
      "sign_up": "Registrarse"
    },
    "helpers": {
      "name": {
        "address": {
          "apartment": "Edificio / Apartamento / Extensión",
          "contact_name": "Nombre de contacto *",
          "door": "Número de puerta *",
          "name": "Alias *",
          "notes": "Referencias",
          "phone": "Teléfono",
          "phone_mobile": "Teléfono móvil",
          "sector": "Sector *",
          "shipping_zone_id": "Ciudad / Provincia *",
          "street": "Calle *"
        },
        "bucket": {
          "name": "Nombre",
          "plan": "Plan"
        },
        "discount": {
          "code": "Código (opcional)"
        },
        "order": {
          "user_id": "Cliente"
        },
        "payment_paypal": {
          "email": "Correo de PayPal"
        },
        "product": {
          "barcode": "Barcode",
          "discounted_price": "Precio con descuento",
          "featured_image": "Imagen destacada",
          "featured_image_alt": "Texto alterno de imagen destacada",
          "height_value": "Alto",
          "images": "Galería",
          "kind": "Tipo",
          "length_value": "Largo",
          "name": "Nombre",
          "package_barcode": "Barcode CAR",
          "price": "Precio",
          "sku": "SKU",
          "status": "Estado",
          "weight_value": "Peso",
          "width_value": "Ancho"
        },
        "user": {
          "company_name": "Nombre de la Empresa",
          "company_rnc": "RNC",
          "current_password": "Contraseña actual",
          "email": "Correo electrónico",
          "first_name": "Nombre",
          "has_whatsapp": "¿WhatsApp disponible?",
          "identification": "Identificación",
          "kind": "Tipo de usuario",
          "last_name": "Apellido",
          "password": "Contraseña",
          "password_confirmation": "Repetir contraseña",
          "phone": "Teléfono",
          "phone_mobile": "Teléfono móvil",
          "remember_me": "Permanecer conectado",
          "role": "Ról"
        }
      }
    },
    "home": {
      "enter_email": "Ingresa tu correo...",
      "join_newsletter": "Únete a nuestro boletín",
      "join_now": "Únete ahora",
      "newsletter_description": "Suscríbete a Fancy Sinner y sigue recibiendo sorpresas. Hecho a mano, íntimo y solo para ti.",
      "subscribe": "Suscribirse",
      "subscription_box": "Caja de Suscripción Secreta",
      "subscription_description": "Suscríbete desde $24.99/mes para desbloquear sorpresas artesanales cada mes."
    },
    "js": {
      "checkout": {
        "free": "Gratis"
      },
      "confirm": {
        "cancel": "Cancelar",
        "ok": "Aceptar",
        "title": "¿Estás seguro?"
      },
      "dropzone": {
        "cancel_upload": "Cancelar carga",
        "cancel_upload_confirmation": "¿Estás seguro de que quieres cancelar esta carga?",
        "default_message": "Arrastra archivos aquí para subir",
        "fallback_message": "Tu navegador no soporta la carga de archivos con arrastrar y soltar.",
        "fallback_text": "Por favor usa el formulario de respaldo para subir tus archivos.",
        "file_too_big": "El archivo es muy grande ({{filesize}}MiB). Tamaño máximo: {{maxFilesize}}MiB.",
        "file_too_large": "\"%{filename}\" excede el tamaño máximo de %{max_size}MB.",
        "invalid_file_type": "No puedes subir archivos de este tipo.",
        "invalid_image": "\"%{filename}\" no es un archivo de imagen válido.",
        "invalid_type_image_pdf": "Este tipo de archivo no está permitido. Por favor sube una imagen o PDF.",
        "max_files_exceeded": "No puedes subir más archivos.",
        "only_one_file": "Solo se puede subir un archivo.",
        "remove": "Eliminar",
        "remove_file": "Eliminar archivo",
        "response_error": "El servidor respondió con código {{statusCode}}.",
        "select_file_first": "Por favor selecciona un archivo primero",
        "upload_failed": "Error al subir",
        "upload_failed_retry": "Error al subir. Por favor intenta de nuevo."
      },
      "error": "Ocurrió un error",
      "file_size": {
        "bytes": "Bytes",
        "gb": "GB",
        "kb": "KB",
        "mb": "MB",
        "zero_bytes": "0 Bytes"
      },
      "loading": "Cargando...",
      "product": {
        "added_to_cart": "Agregado al carrito",
        "option_not_available": "Opción no disponible",
        "out_of_stock": "Agotado",
        "quantity_updated": "Cantidad actualizada",
        "select_options": "Por favor selecciona todas las opciones"
      },
      "success": "Éxito"
    },
    "landing": {
      "banner": {
        "cta": "Adueñate de la noche",
        "description": "Cada mes, por solo $24.99, una pieza de tentación artesanal llega a tu puerta — lista para elevar tus noches.",
        "title": "La Elegancia Nunca Para"
      },
      "categories": {
        "shop_now": "Comprar Ahora",
        "title": "Categorías"
      },
      "featured_in": {
        "title": "Destacados En"
      },
      "hero": {
        "cta_button": "Hazlo tuyo",
        "description": "Lencería artesanal hecha en República Dominicana y entregada mensualmente para hacer cada momento inolvidable.",
        "email_placeholder": "Tu correo para noches más elegantes…",
        "privacy_note": "Nunca compartimos tus secretos. Ni tu correo. Lo que pasa mientras nos usas queda entre nosotros.",
        "social_proof": "7347 mujeres ya manteniéndolo elegante cada mes.",
        "title_line1": "Eleva tus noches,",
        "title_line2": "una pieza elegante a la vez"
      },
      "how_it_works": {
        "step1_description": "Llena un breve formulario con tus gustos, disgustos y límites. Queremos saber exactamente qué te enciende—o no.",
        "step1_title": "Paso 1: Dinos qué te gusta",
        "step2_description": "Comienza con una suscripción para una pieza sorpresa cada mes. ¿Quieres el set completo? Algunas de nuestras clientas, como en Little Mac, optan por dos suscripciones activas para obtener la fantasía completa.",
        "step2_title": "Paso 2: Elige tu suscripción",
        "step3_description": "Cada mes, recibirás lencería hecha justo para tu gusto. Sin selecciones al azar—solo piezas íntimas que combinan con tu estilo y te hacen sentir increíble.",
        "step3_title": "Paso 3: Disfruta lo que realmente te gusta",
        "title": "Cómo Funciona Fancy Sinner – Solo 3 Pasos Fáciles"
      },
      "newsletter": {
        "cta": "Únete ahora",
        "description": "Suscríbete a Fancy Sinner y sigue recibiendo sorpresas. Hecho a mano, íntimo y solo para ti.",
        "title": "Únete a nuestro boletín"
      },
      "our_pieces": {
        "shop_now": "Comprar Ahora",
        "title": "Nuestras Piezas de Arte"
      },
      "subscriptions": {
        "claim": "Reclamar",
        "one_piece": {
          "description": "Una pieza de lencería artesanal, seleccionada solo para ti. Una sorpresa sensual para elevar tus noches.",
          "name": "Fantasía de Una Pieza",
          "price": "$24.99"
        },
        "title": "Suscripciones",
        "two_piece": {
          "description": "Un set completo de dos piezas, perfectamente combinado para duplicar la elegancia — y la tentación.",
          "name": "Doble Tentación",
          "price": "$49.99"
        }
      },
      "testimonials": {
        "title": "Lo Que Dicen Nuestras Clientas"
      }
    },
    "mailers": {
      "common": {
        "greeting": "Hola %{name},",
        "greeting_default": "Hola,",
        "help_text": "¿Tienes preguntas o necesitas ayuda? Simplemente responde a este correo y nuestro equipo de soporte te ayudará.",
        "team_signature": "- El equipo de Fancy Sinner",
        "thank_you": "¡Gracias por comprar en Fancy Sinner!"
      },
      "experience_booking_mailer": {
        "confirmation": {
          "amount_paid": "Monto Pagado",
          "confirmation_number": "Número de Confirmación",
          "copyright": "© %{year} Fancy Sinner. Todos los derechos reservados.",
          "duration": "Duración",
          "experience": "Experiencia",
          "intro": "¡Gracias por reservar <strong>%{experience_name}</strong>! Estamos emocionados de recibirte a ti y a tu grupo.",
          "max_group_size": "Tamaño Máximo del Grupo",
          "next_step": "Siguiente Paso: Agenda Tu Fecha",
          "people": "%{count} personas",
          "questions": "Si tienes alguna pregunta, no dudes en contactarnos.",
          "schedule_button": "Agendar por WhatsApp",
          "schedule_notice": "Contáctanos por WhatsApp para elegir tu fecha y hora preferida. Confirmaremos la disponibilidad y finalizaremos los detalles.",
          "see_you_soon": "¡Nos vemos pronto!",
          "subject": "Reserva Confirmada - %{experience_name}",
          "title": "¡Tu Reserva está Confirmada!",
          "whatsapp_message": "¡Hola! Acabo de reservar %{experience_name} y me gustaría agendar mi sesión. Mi número de confirmación es %{confirmation_number}."
        }
      },
      "order_mailer": {
        "bank_transfer_pending_review": {
          "bank_transfer": "Transferencia Bancaria",
          "delivery_fee": "Costo de Envío:",
          "discount": "Descuento",
          "intro": "Hemos recibido tu comprobante de pago y nuestro equipo lo está revisando.",
          "payment_details": "Detalles del Pago",
          "payment_method": "Método de Pago:",
          "questions": "Si tienes alguna pregunta, no dudes en contactarnos.",
          "review_notice": "Nuestro equipo verificará tu pago en 1-2 días hábiles. Una vez verificado, recibirás un correo de confirmación con los detalles de tu pedido.",
          "subject": "Pago Recibido - En Revisión",
          "submitted": "Enviado:",
          "subtotal": "Subtotal:",
          "title": "Pago Recibido - En Revisión",
          "total": "Total:",
          "whats_next": "¿Qué Sigue?"
        },
        "bank_transfer_rejected": {
          "alternative": "También puedes intentar realizar un nuevo pedido con un método de pago alternativo.",
          "amount": "Monto:",
          "apology": "Nos disculpamos por cualquier inconveniente.",
          "error_notice": "Si crees que esto fue un error, contáctanos con los detalles de tu transferencia y con gusto investigaremos más.",
          "intro": "Lamentablemente, no pudimos verificar tu pago por transferencia bancaria.",
          "payment_details": "Detalles del Pago",
          "reason": "Razón",
          "subject": "No Se Pudo Verificar el Pago",
          "submitted": "Enviado:",
          "title": "No Se Pudo Verificar el Pago",
          "verify_account": "La transferencia fue realizada a la cuenta bancaria correcta",
          "verify_amount": "Se transfirió el monto correcto",
          "verify_instructions": "Por favor verifica que:",
          "verify_voucher": "La imagen del comprobante/recibo era clara y legible",
          "what_can_you_do": "¿Qué Puedes Hacer?"
        },
        "order_confirmed": {
          "delivery_fee": "Costo de Envío:",
          "discount": "Descuento",
          "intro": "Nos emociona confirmar que tu pedido ha sido recibido y está siendo procesado.",
          "items": "Artículos",
          "order_date": "Fecha del Pedido:",
          "order_details": "Detalles del Pedido",
          "order_number": "Número de Pedido:",
          "payment_method": "Método de Pago:",
          "phone": "Teléfono:",
          "shipping_address": "Dirección de Envío",
          "shipping_notice": "Te enviaremos otro correo cuando tu pedido sea enviado.",
          "subject": "Pedido Confirmado - %{order_number}",
          "subtotal": "Subtotal:",
          "title": "¡Gracias por tu pedido!",
          "total": "Total:"
        }
      },
      "registry_mailer": {
        "gift_received": {
          "gift_details": "Detalles del Regalo",
          "intro": "¡Alguien acaba de comprar un regalo de tu registro <strong>%{registry_name}</strong>!",
          "progress": "Tu registro ahora tiene %{fulfilled} de %{total} artículos comprados.",
          "quantity": "Cantidad:",
          "subject": "¡Alguien compró un regalo de tu registro!",
          "thank_you": "¡Gracias por usar Fancy Sinner!",
          "title": "¡Buenas noticias!",
          "view_registry": "Ver Tu Registro"
        }
      },
      "user_mailer": {
        "email_verification": {
          "action_required": "Debes hacer clic en el enlace de abajo para confirmar que recibiste este correo.",
          "greeting": "Hola,",
          "intro": "Esto es para confirmar que %{email} es el correo que deseas usar en tu cuenta. Si alguna vez pierdes tu contraseña, ahí te enviaremos un enlace de restablecimiento.",
          "link_text": "Sí, usar este correo para mi cuenta",
          "subject": "Verifica tu correo electrónico"
        },
        "invitation_instructions": {
          "greeting": "Hola,",
          "ignore_notice": "Si no deseas aceptar la invitación, por favor ignora este correo. Tu cuenta no será creada hasta que accedas al enlace de arriba y establezcas tu contraseña.",
          "intro": "Alguien te ha invitado a la aplicación, puedes aceptar la invitación a través del enlace de abajo.",
          "link_text": "Aceptar invitación",
          "subject": "Instrucciones de invitación"
        },
        "password_reset": {
          "greeting": "Hola,",
          "ignore_notice": "Si no solicitaste un restablecimiento de contraseña, puedes ignorar este correo de forma segura, expira en 20 minutos. Solo alguien con acceso a esta cuenta de correo puede restablecer tu contraseña.",
          "intro": "¿No recuerdas tu contraseña para <strong>%{email}</strong>? No te preocupes, pasa. Solo haz clic en el enlace de abajo para establecer una nueva.",
          "link_text": "Restablecer mi contraseña",
          "subject": "Restablece tu contraseña"
        },
        "passwordless": {
          "code_valid_notice": "Este código solo será válido por los próximos 60 minutos:",
          "link_valid_notice": "Este enlace y código solo serán válidos por los próximos 60 minutos. Si el enlace no funciona, puedes usar el código de verificación directamente:",
          "login_button": "Ingresar a Fancy Sinner",
          "subject": "Ingresa a Fancy Sinner",
          "title": "Tu código de acceso para Fancy Sinner"
        }
      }
    },
    "masquerade": {
      "exit": "Salir",
      "session_as": "Sesión como %{name}",
      "signed_in": "Sesión iniciada exitosamente",
      "signed_out": "Sesión cerrada exitosamente"
    },
    "nav": {
      "all_products": "Todos los Productos",
      "experiences": "Experiencias",
      "how_it_works": "Cómo Funciona",
      "no_categories_available": "No hay categorías disponibles",
      "no_experiences_available": "No hay experiencias disponibles",
      "our_pieces_of_art": "Nuestras Piezas de Arte",
      "store": "Tienda",
      "subscriptions": "Suscripciones"
    },
    "orders": {
      "billing_address": "Dirección de Facturación",
      "delivery_fee": "Costo de Envío",
      "discount": "Descuento",
      "gift_from": "Regalo de %{registry_name}",
      "items": "Artículos",
      "more_items": "+%{count} más",
      "no_orders": "Aún no hay pedidos",
      "no_orders_message": "Cuando realices un pedido, aparecerá aquí.",
      "order": "Pedido",
      "order_date": "Fecha del Pedido",
      "order_number": "Pedido %{number}",
      "order_on_way": "Está en camino hacia ti.",
      "order_picked_up": "Pedido recogido.",
      "order_placed_on": "Pedido realizado el",
      "order_received": "Pedido recibido.",
      "order_received_notice": "Comenzaremos a preparar tu pedido pronto.",
      "order_shipped": "¡Tu pedido ha sido enviado!",
      "paid_via": "Pagado con",
      "payment": "Pago",
      "phone": "Teléfono",
      "pickup_location": "Lugar de Recogida",
      "pickup_ready": "¡Tu pedido está listo para recoger!",
      "pickup_ready_notice": "Por favor trae una identificación válida al recoger tu pedido.",
      "preparing_notice": "Te notificaremos cuando esté listo para recoger.",
      "preparing_order": "Estamos preparando tu pedido.",
      "preparing_shipment": "Estamos preparando tu pedido para envío.",
      "qty": "Cant",
      "shipping_address": "Dirección de Envío",
      "start_shopping": "Comenzar a Comprar",
      "status": "Estado",
      "store_name": "Tienda Fancy Sinner",
      "subtotal": "Subtotal",
      "thank_you": "¡Gracias por comprar con nosotros!",
      "title": "Mis Pedidos",
      "total": "Total",
      "view_details": "Ver Detalles"
    },
    "payments": {
      "bank_transfer": {
        "pending_review": "Pago pendiente de revisión",
        "return_to_cart": "Volver al Carrito",
        "title": "Transferencia Bancaria",
        "upload_voucher": "Subir Comprobante",
        "view_order": "Ver Pedido",
        "voucher_already_uploaded": "El comprobante ya fue subido",
        "voucher_required": "Por favor sube un comprobante",
        "voucher_uploaded": "Comprobante subido exitosamente"
      }
    },
    "posts": {
      "no_posts": "Aún no hay publicaciones",
      "no_posts_message": "¡Vuelve pronto para nuevos artículos!",
      "published_on": "Publicado el %{date}",
      "read_more": "Leer Más",
      "title": "Fancy Blog"
    },
    "products": {
      "add_to_cart": "Agregar al Carrito",
      "add_to_registry": "Agregar al Registro",
      "additional_info": "Información adicional",
      "color": "Color:",
      "create_new_registry": "+ Crear Nuevo Registro",
      "create_registry": "Crear un Registro",
      "delivery_info": "Entrega en 1-3 días hábiles, 7-14 a EE.UU.",
      "from_price": "Desde %{price}",
      "in_stock": "En Stock",
      "made_to_order": "Hecho a Pedido",
      "made_with_love": "Hecho con amor en República Dominicana",
      "material": "Material",
      "model_wearing": "La modelo usa \"%{size}\".",
      "out_of_stock": "Agotado",
      "pick_color": "Elige un color:",
      "pick_size": "Elige una talla:",
      "pick_your_size": "Elige tu talla",
      "product_spec": "Especificaciones",
      "related_products": "Productos Relacionados",
      "return_policies": "Políticas de devolución",
      "select_color": "Seleccionar Color",
      "select_size": "Seleccionar Talla",
      "size": "Talla:"
    },
    "profiles": {
      "build_again": "Crear de nuevo",
      "build_description": "Guarda tus tallas, preferencias y detalles para comprar más rápido e inteligente. Un perfil completo significa un checkout más fluido y una experiencia de compra hecha solo para ti.",
      "build_your_profile": "Completa tu perfil",
      "complete_your_profile": "Completa tu perfil",
      "fields": {
        "belly_size": "Talla de cintura:",
        "bottom_size": "Talla inferior:",
        "bottoms_preference": "Preferencia de partes inferiores:",
        "bra_size": "Talla de brasier:",
        "excluded_colors": "Colores excluidos:",
        "favorite_colors": "Colores favoritos:",
        "occasion_preference": "Preferencia de ocasión:",
        "packaging": "Empaque:",
        "prints_preference": "Preferencia de estampados:",
        "sexy_rating": "Nivel de sensualidad:",
        "thongs_rating": "Nivel de tangas:"
      },
      "sections": {
        "delivery": "Entrega",
        "fit": "Tallas",
        "preferences": "Preferencias"
      },
      "sidebar": {
        "experience_bookings": "Reservas de Experiencias",
        "free": "Gratis - ",
        "gift_registry": "Registro de Regalos",
        "manage_subscription": "Gestionar Suscripción",
        "orders": "Pedidos",
        "profile_overview": "Resumen del Perfil",
        "your_information": "Tu Información"
      },
      "title": "Resumen del Perfil"
    },
    "registries": {
      "add_gift_to_cart": "Agregar Regalo al Carrito",
      "add_items": {
        "browse": "Explorar Productos",
        "description": "Explora nuestra colección y agrega artículos que te gustaría recibir.",
        "title": "Agregar Artículos a Tu Registro"
      },
      "anonymous": "Anónimo",
      "create_first": "Crea tu Primer Registro",
      "create_new": "Crear Registro",
      "create_title": "Crear Registro de Regalo",
      "created": "Registro creado exitosamente.",
      "days_away": {
        "one": "1 día restante",
        "other": "%{count} días restantes"
      },
      "delete_confirm": "¿Estás seguro de que deseas eliminar este registro? Esta acción no se puede deshacer.",
      "delete_registry": "Eliminar Registro",
      "deleted": "Registro eliminado.",
      "edit_heading": "Editar Registro",
      "edit_title": "Editar %{name}",
      "event_passed": "Evento pasado",
      "event_today": "¡Hoy!",
      "event_types": {
        "anniversary": "Aniversario",
        "baby_shower": "Baby Shower",
        "birthday": "Cumpleaños",
        "graduation": "Graduación",
        "housewarming": "Inauguración de Casa",
        "other": "Otro",
        "wedding": "Boda"
      },
      "form": {
        "create": "Crear Registro",
        "event_date_hint": "Opcional - la fecha de tu ocasión especial",
        "fix_errors": "Por favor corrige los siguientes errores:",
        "name_placeholder": "ej., Nuestro Registro de Boda",
        "select_occasion": "Seleccionar ocasión...",
        "update": "Actualizar Registro"
      },
      "from": "De:",
      "gifts_count": {
        "one": "1 regalo",
        "other": "%{count} regalos"
      },
      "gifts_received": "Regalos Recibidos",
      "items_count": {
        "one": "1 artículo",
        "other": "%{count} artículos"
      },
      "no_items": "Aún no hay artículos en tu registro.",
      "no_items_hint": "Explora nuestra colección para agregar artículos.",
      "no_registries": "Aún no hay registros",
      "no_registries_message": "Crea un registro de regalo para tu ocasión especial.",
      "partial_purchased": "%{purchased}/%{total} comprados",
      "priority": "Prioridad",
      "purchased": "Comprado",
      "purchased_count": {
        "one": "1 comprado",
        "other": "%{count} comprados"
      },
      "qty": "Cant:",
      "registry_items": "Artículos del Registro",
      "remove_confirm": "¿Eliminar este artículo de tu registro?",
      "share": {
        "copied": "¡Copiado!",
        "copy": "Copiar",
        "description": "Envía este enlace a amigos y familiares:",
        "title": "Comparte tu registro"
      },
      "title": "Mis Registros de Regalo",
      "updated": "Registro actualizado exitosamente.",
      "visibility": {
        "hidden": "Privado",
        "link_only": "Solo con Enlace",
        "public_visible": "Público"
      },
      "visibility_options": {
        "hidden": "Privado - Solo tú puedes ver",
        "link_only": "Solo con Enlace - Cualquiera con el enlace puede ver",
        "public_visible": "Público - Visible para todos"
      }
    },
    "search": {
      "no_results": "No se encontraron productos",
      "placeholder": "Buscar productos...",
      "title": "Buscar",
      "try_different": "Intenta con un término diferente"
    },
    "sign_in": "Ingresar",
    "sign_up": "Registrar",
    "subscriptions": {
      "claim": "Reclamar",
      "continue": "Continuar",
      "delivery": {
        "do_description": "Entrega en aproximadamente 5 días hábiles — hecho localmente, rápido a tu puerta.",
        "dominican_republic": "República Dominicana",
        "title": "Dinos dónde entregar tu Caja Fancy",
        "united_states": "Estados Unidos",
        "us_description": "Entrega en 7–14 días hábiles — con un toque extra de cuidado."
      },
      "fancy_secret": "Suscripción Secreta Fancy",
      "faqs": {
        "q1_answer": "Cada mes, recibirás una pieza de lencería artesanal (o un set, dependiendo de tu plan), cuidadosamente seleccionada para sorprenderte y elevar tus momentos íntimos. Cada caja es única, sensual y hecha con amor en República Dominicana.",
        "q1_question": "¿Qué incluye mi Caja de Suscripción Secreta Fancy?",
        "q2_answer": "Absolutamente. Siempre tienes el control — puedes pausar, saltar un mes o cancelar en cualquier momento desde tu panel de cuenta. Sin preguntas.",
        "q2_question": "¿Puedo pausar o cancelar mi suscripción?",
        "q3_answer": "Procesamos y enviamos tu primera caja dentro de 3–5 días hábiles después de tu pedido. La entrega toma aproximadamente 5 días hábiles en República Dominicana y 10–14 días hábiles en Estados Unidos.",
        "q3_question": "¿Cuándo recibiré mi primera caja?",
        "q4_answer": "Curamos cada caja basándonos en tu plan seleccionado y nuestra colección actual de lencería artesanal. Buscamos sorprenderte con piezas que se sientan atrevidas, elegantes e inolvidables.",
        "q4_question": "¿Cómo eligen las piezas que recibo?",
        "q5_answer": "Sí — todas nuestras cajas se envían en empaque simple y discreto para mantener tu sorpresa privada hasta que la abras.",
        "q5_question": "¿Ofrecen empaque discreto?",
        "title": "Preguntas frecuentes"
      },
      "featured_in": "Destacados En",
      "frequency": {
        "monthly": "Mensual",
        "monthly_description": "Facturado cada mes — flexibilidad para pausar o cancelar en cualquier momento.",
        "yearly": "Anual",
        "yearly_one_piece_annual": "$269.99 facturado anualmente — <span class=\"font-bold text-accent-red\">ahorra $30 y comprométete a un año de tentación.</span>",
        "yearly_two_piece_annual": "$539.99 facturado anualmente — <span class=\"font-bold text-accent-red\">ahorra $30 y comprométete a un año de tentación.</span>"
      },
      "invitation": {
        "email_address": "Correo Electrónico",
        "email_placeholder": "Tu correo para noches más elegantes…",
        "enter_your": "Ingresa tu",
        "hero_description": "Lencería artesanal hecha en República Dominicana y entregada mensualmente para hacer cada noche inolvidable.",
        "hero_title_line1": "Eleva tus noches,",
        "hero_title_line2": "una pieza elegante a la vez",
        "make_it_yours": "Hazlo tuyo",
        "privacy_note": "Nunca compartimos tus secretos. Ni tu correo. Lo que pasa mientras nos usas queda entre nosotros.",
        "social_proof": "7347 mujeres ya manteniéndolo elegante cada mes."
      },
      "invitation_sent": {
        "message": "Hemos enviado tu invitación. Por favor revisa tu bandeja de entrada.",
        "no_email": "¿No recibiste el correo?",
        "title": "Invitación enviada",
        "try_again": "Intentar de nuevo"
      },
      "must_pick_frequency": "Debes elegir una frecuencia",
      "must_pick_plan": "Debes elegir un plan",
      "pick_frequency": "Elige una frecuencia",
      "pick_plan": "Elige un plan",
      "plans": {
        "one_piece": {
          "description": "Una pieza de lencería artesanal, seleccionada solo para ti. Una sorpresa sensual para elevar tus noches.",
          "name": "Fantasía de Una Pieza",
          "price": "$24.99"
        },
        "two_piece": {
          "description": "Un set completo de dos piezas, perfectamente combinado para duplicar la elegancia — y la tentación.",
          "name": "Doble Tentación",
          "price": "$49.99"
        }
      },
      "press": {
        "listin_diario": "Laura Peña revolucionó la pasarela de DominicanaModa con su colección \"The Jaguar\"",
        "nacional": "<b>Una apuesta por la moda dominicana</b>, selección criolla apoyará a diseñadores y proyectos emprendimientos",
        "nuevo_diario": "\"El glamour y la sensualidad de fancy Sinner Lingirie se lucen en <b>Dominicana Moda</b>\"",
        "pandora": "Laura Peña nos sumerge en el universo de Fancy Sinner"
      },
      "select_your": "Selecciona tu",
      "title": "Suscripciones",
      "your_way": "Tu suscripción, a tu manera:"
    },
    "time": {
      "am": "am",
      "formats": {
        "datetime": "%-d/%-m/%Y %I:%M %p",
        "default": "%A, %-d de %B de %Y %I:%M:%S %z %p",
        "long": "%-d de %B de %Y %I:%M %p",
        "short": "%-d de %b, %I:%M %p",
        "time": "%I:%M %p"
      },
      "pm": "pm"
    }
  }
}
